export const EVENT_ROUTE_CHANGE_START = 'EVENT_ROUTE_CHANGE_START';

export const EVENT_SHOW_OMNISEARCH = 'EVENT_SHOW_OMNISEARCH';
export const EVENT_HIDE_OMNISEARCH = 'EVENT_HIDE_OMNISEARCH';
